import { render, staticRenderFns } from "./BrandBox.vue?vue&type=template&id=6aced1ef&"
import script from "./BrandBox.js?vue&type=script&lang=js&"
export * from "./BrandBox.js?vue&type=script&lang=js&"
import style0 from "./BrandBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports